import React, { FC } from 'react'
import { useForm } from 'react-hook-form'
import {
  Alert,
  AlertIcon,
  AlertTitle,
  Button,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  Flex,
  Heading,
  Stack,
  Text,
} from '@chakra-ui/react'

import { UnifiedPersonFilter } from 'CitizenProfile/types'
import CitizenFilterForm from 'CitizenProfile/components/CitizenFilterForm'
import { UNIFIED_PERSON_INITIAL_FILTER } from 'CitizenProfile/constants/pages/unifiedPeople'
import { useCustomFormUnifiedPersonSelectionDrawerManager } from '../../contexts/CustomFormUnifiedPersonSelectionDrawerManager/Provider'
import CustomFormFilterWarningAlert from '../../../../components/CustomFormFilterWarningAlert'

type Props = {
  onClose: () => void
}

const SearchUnifiedPersonOnCustomForm: FC<Props> = ({ onClose }) => {
  const { handleSubmit, register } = useForm<UnifiedPersonFilter>({ defaultValues: UNIFIED_PERSON_INITIAL_FILTER })

  const { setView, filter, setFilter } = useCustomFormUnifiedPersonSelectionDrawerManager()

  async function onSubmit(unifiedPersonFilter: UnifiedPersonFilter) {
    setFilter({ ...filter, ...unifiedPersonFilter })
    setView('SELECT_UNIFIED_PERSON')
  }

  return (
    <>
      <DrawerHeader>
        <Text>Selecionar uma pessoa unificada</Text>
        <Heading color="primary">Pesquisar as pessoas unificadas</Heading>
      </DrawerHeader>

      <DrawerBody>
        <Stack spacing={4}>
          <Alert status="info" rounded="md" mb={4}>
            <AlertIcon />
            <Flex direction="column">
              <AlertTitle>Precisamos do máximo de informação</AlertTitle>
              <Text fontWeight="500">Coloque o máximo de informações possíveis para listar pelo menos 20 pessoas.</Text>
            </Flex>
          </Alert>

          <CustomFormFilterWarningAlert />

          <CitizenFilterForm
            onlyFields={[
              'name',
              'mother_name',
              'father_name',
              'cpf_number',
              'cns_number',
              'cnh_number',
              'rg_number',
              'sex',
              'ctps_pis_number',
              'social_name',
            ]}
            register={register}
          />
        </Stack>
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={onClose}>
          Fechar
        </Button>

        <Button onClick={() => handleSubmit(onSubmit)()}>Buscar pessoa unificada</Button>
      </DrawerFooter>
    </>
  )
}

export default SearchUnifiedPersonOnCustomForm
